import { UploadChangeParam } from 'antd/es/upload';
import { UploadFile } from 'antd/es/upload/interface';
import { makeAutoObservable } from 'mobx';
import { UploadVideoInterface } from 'type/uploadVideoType';

class UploadVideoStore {
  private videoList: UploadVideoInterface[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public init(): void {
    this.videoList = [];
  }

  public updateProgress(uid: string, percent: number, speed: number): void {
    this.videoList = this.videoList.map((item: UploadVideoInterface) => {
      if (item.uid === uid) {
        return { ...item, percent, speed };
      }
      return item;
    });
  }

  public getUploadVideoList(): UploadVideoInterface[] {
    return this.videoList;
  }

  public clearUploadVideoList(): void {
    this.videoList = [];
  }

  public setUploadVideoList(info: UploadChangeParam<UploadFile<UploadVideoInterface>>): void {
    const newVideoList: UploadVideoInterface[] = Array.from(
      new Set(info.fileList.map(file => file.uid))
    ).map(uid => {
      const file = info.fileList.find(file => file.uid === uid);
      return { ...file, title: file?.name, state: 'normal' };
    }) as UploadVideoInterface[];

    if (this.videoList.length === 0) {
      this.videoList = newVideoList;
    } else {
      const uniqueVideoList = newVideoList.filter(
        newVideo => !this.videoList.some(existingVideo => existingVideo.uid === newVideo.uid)
      );
      this.videoList = [...this.videoList, ...uniqueVideoList];
    }
  }

  public removeUploadVideoList(id: string): void {
    this.videoList = this.videoList.filter(video => video.uid !== id);
  }

  public updateUploadVideo(uploadVideo: UploadVideoInterface): void {
    this.videoList = this.videoList.map(video => {
      if (video.uid === uploadVideo.uid) {
        return uploadVideo;
      }
      return video;
    });
  }
}

export const uploadVideoStore = new UploadVideoStore();
